import { z } from "zod";
import { OpeningStatusSchema } from "./enums.js";

/** An opening (seat) a role is trying to fill. Openings within a role are the SAME role (identical
 *  designation) — a role's headcount = its opening count. `filledBy` names the winning application. */
export const OpeningSchema = z.object({
  id: z.uuid(),
  searchId: z.uuid(),
  label: z.string(),
  sortIndex: z.number().int(),
  status: OpeningStatusSchema,
  /** the candidate_search (application) that filled this seat, if any */
  filledBy: z.uuid().nullable(),
  filledAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Opening = z.infer<typeof OpeningSchema>;

export const OpeningCreateSchema = z.object({
  label: z.string().min(1).max(120),
  sortIndex: z.number().int().nonnegative().optional(),
  status: OpeningStatusSchema.optional(),
});
export type OpeningCreate = z.infer<typeof OpeningCreateSchema>;

export const OpeningUpdateSchema = z
  .object({
    label: z.string().min(1).max(120).optional(),
    sortIndex: z.number().int().nonnegative().optional(),
    status: OpeningStatusSchema.optional(),
    /** set the placed application as the winner (fills the seat) or null to reopen it */
    filledBy: z.uuid().nullable().optional(),
  })
  .refine((v) => Object.keys(v).length > 0, { message: "empty update" });
export type OpeningUpdate = z.infer<typeof OpeningUpdateSchema>;
